import { render, staticRenderFns } from "./CollapseItems.vue?vue&type=template&id=6f6d6164"
import script from "./CollapseItems.vue?vue&type=script&lang=js"
export * from "./CollapseItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports